import { useMediaQuery } from '@mui/material';

const useIsSmallMobileScreen = () => {
   return useMediaQuery(`(max-width: 374px)`);
};

export default useIsSmallMobileScreen;
